import { render, staticRenderFns } from "./EmployeeInvestmentInfo.vue?vue&type=template&id=89fb02ea"
import script from "./EmployeeInvestmentInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInvestmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports